// 4 Grand-Popo tourist circuits — sourced from official flyers
// Office de Tourisme Grand-Popo / Bénin

export const CIRCUITS = [
  {
    id: "bouche-du-roy",
    number: "01",
    durationFr: "2h30 à 3h",
    durationEn: "2h30 to 3h",
    meansFr: "Barque motorisée couverte (protection soleil & pluie)",
    meansEn: "Covered motorized boat (sun & rain protection)",
    image:
      "https://customer-assets.emergentagent.com/job_bambou-beach-booking/artifacts/35km7gcz_Circuit%20touristique%201%20de%20grand-popo.jpg",
    titleFr: "Biodiversité du delta du Mono — La Bouche du Roy",
    titleEn: "Biodiversity of the Mono Delta — The King's Mouth",
    overlineFr: "Réserve de biosphère",
    overlineEn: "Biosphere reserve",
    introFr:
      "Une traversée sur le fleuve Mono jusqu'à sa rencontre avec l'Atlantique. L'écosystème le plus riche de Grand-Popo, entre îles, mangroves et marécages.",
    introEn:
      "A crossing on the Mono river to where it meets the Atlantic. Grand-Popo's richest ecosystem — islands, mangroves, and marshes.",
    stopsFr: [
      "Site de protection des tortues de mer — possibilité de voir des bébés tortues",
      "Île aux oiseaux : espèces migratrices et histoire écologique",
      "Tunnel géant de la mangrove et son écosystème",
      "Île de production du sel, menée par une association de femmes",
      "Dégustation de noix de coco fraîche (rafraîchissante et préventive contre le paludisme)",
      "Observation des techniques de pêche traditionnelles de Grand-Popo",
      "Bouche du Roy — embouchure du Mono, paysage incroyable entre île, mangrove et marécages",
    ],
    stopsEn: [
      "Sea turtle conservation site — with a chance to see baby turtles",
      "Bird island: migratory species and ecological history",
      "Giant mangrove tunnel and its ecosystem",
      "Salt production island, run by a women's association",
      "Fresh coconut tasting (refreshing and natural anti-malarial)",
      "Observation of Grand-Popo's traditional fishing techniques",
      "The King's Mouth — delta of the Mono, stunning landscape between island, mangrove and marshes",
    ],
    noteFr:
      "Pique-nique, pêche ou baignade à la Bouche du Roy possibles en supplément, sur demande.",
    noteEn:
      "Picnic, fishing or swimming at the King's Mouth available as extras, on request.",
  },
  {
    id: "nature-culture",
    number: "02",
    durationFr: "2h (prolongeable, prix inchangé)",
    durationEn: "2h (can be extended, price unchanged)",
    meansFr: "Pirogue à rame sécurisée",
    meansEn: "Secured rowing pirogue",
    image:
      "https://customer-assets.emergentagent.com/job_bambou-beach-booking/artifacts/xpphw24l_Circuit%20touristique%202%20de%20grand-popo.jpg",
    titleFr: "Cocktail Nature & Culture",
    titleEn: "Nature & Culture Cocktail",
    overlineFr: "Mangrove & Vodoun",
    overlineEn: "Mangrove & Vodoun",
    introFr:
      "Un rythme plus lent, à la rame, pour explorer la mangrove et entrer dans un village où la tradition Vodoun vit au quotidien.",
    introEn:
      "A slower pace, under oars, to explore the mangrove and step into a village where the Vodoun tradition lives every day.",
    stopsFr: [
      "Site de protection des tortues de mer — possibilité de voir des bébés tortues",
      "Balade en pirogue paisible dans la mangrove avec explications détaillées sur son importance et ses composantes",
      "Technique de pêche aux écrevisses d'eau douce, suivie d'une dégustation de noix de coco fraîche",
      "Village des réalités Vodoun — diversité de pratiques cultuelles et rencontres authentiques",
    ],
    stopsEn: [
      "Sea turtle conservation site — with a chance to see baby turtles",
      "Peaceful pirogue ride in the mangrove with detailed explanations of its importance and components",
      "Freshwater crayfish fishing technique, followed by a fresh coconut tasting",
      "Vodoun realities village — diversity of cultural practices and authentic encounters",
    ],
    noteFr:
      "Possible de combiner avec le circuit Bouche du Roy. Matin ou soir.",
    noteEn:
      "Can be combined with the King's Mouth circuit. Morning or evening.",
  },
  {
    id: "villegiature-peulh",
    number: "03",
    durationFr: "2h — impérativement entre 10h et 12h",
    durationEn: "2h — strictly between 10am and 12pm",
    meansFr: "Voiture, moto, vélo ou bus",
    meansEn: "Car, motorcycle, bicycle or bus",
    image:
      "https://customer-assets.emergentagent.com/job_bambou-beach-booking/artifacts/xc6380vh_Circuit%20touristique%203%20de%20grand-popo.jpg",
    titleFr: "Villégiature Peulh — fromage fermier",
    titleEn: "Fulani Retreat — farmhouse cheese",
    overlineFr: "À 6 km du centre de Grand-Popo",
    overlineEn: "6 km from downtown Grand-Popo",
    introFr:
      "Un campement peulh dans un environnement rural, où l'on prépare soi-même le fromage — du lait caillé à la dégustation.",
    introEn:
      "A Fulani camp in a rural setting, where you make the cheese yourself — from curdling to tasting.",
    stopsFr: [
      "Arrivée et installation au campement peulh",
      "Participation au traitement de la présure végétale",
      "Participation aux étapes de la préparation du fromage",
      "Moulage des fromages dans les osiers, puis dégustation",
    ],
    stopsEn: [
      "Arrival and installation at the Fulani camp",
      "Hands-on vegetable rennet preparation",
      "Hands-on cheese-making steps",
      "Molding the cheeses in wicker baskets, then tasting",
    ],
    noteFr:
      "Les visiteurs peuvent repartir avec du fromage. Expérience sympathique du mode de vie peulh.",
    noteEn:
      "Visitors can take cheese home. A warm, practical experience of Fulani life.",
  },
  {
    id: "activites-socio-economiques",
    number: "04",
    durationFr: "3h30 à 4h",
    durationEn: "3h30 to 4h",
    meansFr: "Barque motorisée couverte",
    meansEn: "Covered motorized boat",
    image:
      "https://customer-assets.emergentagent.com/job_bambou-beach-booking/artifacts/306cdyge_Circuit%20touristique%204%20de%20grand-popo.jpg",
    titleFr:
      "Activités socio-économiques de la Réserve du Mono",
    titleEn: "Socio-economic activities of the Mono Reserve",
    overlineFr: "Réserve de biosphère · immersion",
    overlineEn: "Biosphere reserve · immersion",
    introFr:
      "Une version plus profonde du circuit 01 : en plus des paysages, vous prenez part à une activité économique de la réserve — huîtres, caramel de coco, sel…",
    introEn:
      "A deeper version of circuit 01: beyond the landscapes, you take part in one of the reserve's economic activities — oysters, coconut caramel, salt…",
    stopsFr: [
      "Île aux oiseaux et son histoire écologique",
      "Tunnel géant de la mangrove",
      "Île de production du sel et son association de femmes",
      "Dégustation de noix de coco fraîche",
      "Participation complète à une activité au choix : huîtres, caramel de coco (toffee) ou sel",
      "Observation des techniques de pêche traditionnelles",
      "Bouche du Roy — embouchure du fleuve Mono",
    ],
    stopsEn: [
      "Bird island and its ecological history",
      "Giant mangrove tunnel",
      "Salt production island and its women's association",
      "Fresh coconut tasting",
      "Full hands-on participation in one activity of your choice: oysters, coconut caramel (toffee), or salt",
      "Observation of traditional fishing techniques",
      "The King's Mouth — mouth of the Mono river",
    ],
    noteFr:
      "Pique-nique, pêche ou baignade à la Bouche du Roy en supplément, sur demande.",
    noteEn:
      "Picnic, fishing or swimming at the King's Mouth as extras, on request.",
  },
];
